import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface DbTestimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  service?: string | null;
  content: string;
  rating: number;
  avatar_url: string | null;
}

export function useTestimonials() {
  const [testimonials, setTestimonials] = useState<DbTestimonial[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("testimonials")
        .select("*")
        .order("display_order");
      if (data) setTestimonials(data as DbTestimonial[]);
      setLoading(false);
    };
    fetch();
  }, []);

  return { testimonials, loading };
}
